import { STUDENT_BADGE_STATUS } from '@cuemath/intel';
import { ACTIONS } from 'actions/rewards-home';
import { utils as reducerUtils } from 'redux-rest-reducer';
import { getCurrentSelectedProgram } from 'utils/program';

import RestReducer from './reducer';

const SENT = 'SENT';

export default RestReducer(ACTIONS, (state, { type, payload }) => {
  const { id: payloadId, query } = payload || {};

  switch (type) {
    case ACTIONS.INVALIDATE_ITEM:
      return reducerUtils.changeItemToStale(state, payloadId, query);
    default:
      return state;
  }
});

export function getRewardsHomeQuery(studentClassroomId, studentCurriculumHome) {
  const { data: curriculumData } = studentCurriculumHome || {};
  const { user_programs: userPrograms } = curriculumData || {};
  const currentProgram = getCurrentSelectedProgram(userPrograms);
  const {
    badges_enabled: isProgramBadgesEnabled,
    id: programId,
    rewards_enabled: isProgramRewardsEnabled,
  } = currentProgram || {};
  const badges = !!isProgramBadgesEnabled;
  const stickers = !!studentClassroomId;

  const rewardHomeQuery = {
    program_id: programId,
    rewards: isProgramRewardsEnabled,
    badges,
    ...(badges && { badges_state: STUDENT_BADGE_STATUS.ASSIGNED }),
    stickers,
    ...(stickers && {
      student_classroom_id: studentClassroomId,
      state: SENT,
    }),
  };

  return rewardHomeQuery;
}

export function getWinsTabRewardsHomeQuery(
  currentProgram,
  isMilestonePlanEnabled = false,
) {
  const {
    badges_enabled: isProgramBadgesEnabled,
    id: currentProgramId,
    rewards_enabled: isProgramRewardsEnabled,
  } = currentProgram || {};
  const badges = isMilestonePlanEnabled || !!isProgramBadgesEnabled;
  const rewards = isMilestonePlanEnabled || !!isProgramRewardsEnabled;

  const query = {
    badges,
    program_id: isMilestonePlanEnabled ? null : currentProgramId,
    rewards,
    stickers: true,
  };

  if (isMilestonePlanEnabled) delete query.program_id;

  return query;
}

export const getWinsTabRewardQuery = enrolledPrograms => {
  if (!enrolledPrograms) return null;

  const currentProgram = getCurrentSelectedProgram(enrolledPrograms);
  const winsQuery = getWinsTabRewardsHomeQuery(currentProgram);

  return winsQuery;
};
